import { AnnotationsStatuses, AnnotationTypes, DefectTypes, DefectStatusTypes, MeasurementStatus } from './enums'

interface ImageAnnotationType {
  annotationId?: number
  annotationUuid?: string
  annotationGroup?: number
  tempAnnotationUuid?: string
  identifier?: string
  annotationStatus?: AnnotationsStatuses
  annotationType: AnnotationTypes
  defectBounds: Array<Array<number>>
  defectType: DefectTypes
  defectStatus: DefectStatusTypes
  defectSurfaceArea: number
  defectSurfaceAreaUnits: string
  defectSurfaceAreaUncertainty: number
  defectSurfaceAreaUncertaintyUnits: string
  surfaceAreaStatus: MeasurementStatus
  defectComment: string
  isAnnotation?: boolean
  isNew: boolean
  isTemp: boolean
  isHovered?: boolean
  pendingDeletion: boolean
  confidence?: number
}

type AnnotationUpdate = {
  defectType?: DefectTypes
  defectStatus?: DefectStatusTypes
  defectComment?: string
}

// Ensure that at least one key is required
type AtLeastOne<T> = {
  [K in keyof T]-?: Pick<T, K> & Partial<Omit<T, K>>
}[keyof T]

// The type for the function's parameter
type AnnotationUpdateWithAtLeastOneKey = AtLeastOne<AnnotationUpdate>

class ImageAnnotation implements ImageAnnotationType {
  annotationId?: number
  annotationUuid?: string
  annotationGroup?: number
  tempAnnotationUuid?: string
  identifier?: string
  annotationStatus?: AnnotationsStatuses
  annotationType: AnnotationTypes
  defectBounds: Array<Array<number>>
  defectType: DefectTypes
  defectStatus: DefectStatusTypes
  defectComment: string
  defectSurfaceArea: number
  defectSurfaceAreaUnits: string
  defectSurfaceAreaUncertainty: number
  defectSurfaceAreaUncertaintyUnits: string
  surfaceAreaStatus = MeasurementStatus.Pending
  isAnnotation?: boolean
  isNew = false
  isTemp = false
  isHovered?: boolean
  pendingDeletion = false
  confidence?: number

  constructor(
    annotationId,
    annotationUUID,
    annotationType,
    defectBounds,
    defectType,
    defectStatus,
    defectComment,
    isAnnotation,
    isTemp,
    confidence
  ) {
    this.annotationId = annotationId
    this.annotationUuid = annotationUUID
    this.identifier = null
    this.annotationType = annotationType
    this.defectBounds = defectBounds
    this.defectType = defectType
    this.defectStatus = defectStatus
    this.defectComment = defectComment
    this.isAnnotation = isAnnotation
    this.isTemp = isTemp
    this.confidence = confidence
  }
}

export type { ImageAnnotationType, AnnotationUpdateWithAtLeastOneKey }
export { ImageAnnotation }
